<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo">
      <el-menu-item index="1" @click="toNewRouter('customer-flow-over-view')" v-if="permissionCodes.indexOf('043001000') !== -1">
        <i class="el-icon-damai-shujulaiyuan"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-menu-item index="2" @click="toNewRouter('monitor-point-management')" v-if="permissionCodes.indexOf('043002000') !== -1">
        <i class="el-icon-damai-ic_jiancedianguanli"></i>
        <span slot="title">监测点管理</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('customer-flow-statistics')" v-if="permissionCodes.indexOf('043003000') !== -1">
        <i class="el-icon-damai-ic_keliutongji"></i>
        <span slot="title">客流统计</span>
      </el-menu-item>      
      <el-menu-item index="4" @click="toNewRouter('customer-log')" v-if="permissionCodes.indexOf('043004000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
     </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "customer-flow-over-view",
  2: [
    "monitor-point-management",
    "monitor-point-management-add",
    "monitor-point-management-modify"
  ],
  3: "customer-flow-statistics",
  4: "customer-log"
});

export default {
  name: "customer-flow-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    }
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", data => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/CustomerFlow/CustomerFlowNav.vue